module.exports = __webpack_public_path__ + "static/img/swiper3.86832ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/swiper3.jpg
// module id = kYav
// module chunks = 1